module.exports = __webpack_public_path__ + "img/qacard1.a12da7d9.png";